import React from "react";
import ConfirmDialog from "./ConfirmDialog";

const DiscardDialog = ({ onStay, onLeave }) => (
  <ConfirmDialog
    message="Are you sure you want to discard the changes?"
    cancelLabel="Stay"
    confirmLabel="Leave"
    onCancel={onStay}
    onConfirm={onLeave}
  />
);

export default DiscardDialog;
